import { useState } from 'react';
import Select from 'react-select';

import { useField } from 'formik';
import { customStyles } from '@/theme/components/select';
import { NoOptionsMessage } from '@/components/select';

export const FormSelect = ({
  options = [],
  selected: defaultValue = null,
  fieldName,
  placeholder = 'Select',
  ...props
}) => {
  const [selected, setSelected] = useState(defaultValue);
  const [_field, meta, helpers] = useField(fieldName); // eslint-disable-line
  const { setValue, setTouched, setError } = helpers;
  const { error, touched } = meta;

  const onChange = (selected) => {
    setSelected(selected);
    setValue(selected);
    setTouched(true);
    setError(null);
  };

  return (
    <Select
      styles={customStyles}
      options={options}
      hasError={touched && Boolean(error)}
      components={{
        IndicatorSeparator: null,
        NoOptionsMessage,
      }}
      placeholder={placeholder}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      onChange={onChange}
      value={selected}
      {...props}
    />
  );
};
